import React, { useState, useEffect } from "react";
import Candidate from "../../layouts/Candidate";
import { useParams } from "react-router-dom";
import Axios from "axios";
import url from "../../services/url";
import { If, Else } from "react-condition";
import GetFormComponent from "./GetFormComponent";
import PersonalDetails from "./ApplicationView.PersonalDetails";
import slugify from "slugify";
import uploadSizes from "../../services/uploadSizes";
import $, { data } from "jquery";
import cx from "classnames";
import swal from "sweetalert";
import { withRouter } from "react-router";
import axios from "../../services/axios";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";
import Dashboard from "../../layouts/Dashboard";
import { useLocation, useHistory } from "react-router-dom";
import useAxios from "../../hooks/useAxios";

function base64ToFile(
  base64String,
  filename,
  mimeType = "application/octet-stream"
) {
  if (!base64String) return null;

  const base64Data = base64String.replace(/^data:[^;]+;base64,/, "");

  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new File([byteArray], filename, { type: mimeType });
}

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9";

function CandidateEdit(props) {
  // Uncommon Hooks
  //const { id } = useParams();
  const locationUrl = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(locationUrl.search);
  const TAB = searchParams.get("tab" || "");
  const SOURCE_PAGE = searchParams.get("sourcepage" || "");
  const IDS = searchParams.get("ids" || "");
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;

  localStorage.setItem("form_id", id);

  const [load, setLoad] = useState(false);

  // States
  const [form, setForm] = useState({
    name: "Loading form...",
    elements: [],
    candidatePhoto: false,
    candidateVideo: false,
    resume: false,
    trf: {
      title: "Loading form...",
      overview: "Please wait a moment for this to load.",
    },
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [agreed, setAgreed] = useState(false);

  const [candidateInformation, setCandidateInformation] = useState();
  const [errorInputs, setErrorInputs] = useState([]);
  const [locations, setLocations] = useState([]);
  const [courseType, setCourseType] = useState("");
  const [departments, setDepartments] = useState([]);

  const api = useAxios();

  const getFormTemplate = async () => {
    try {
      let { data } = await api.get(`formtemplate/${id}`);
      const results = filterChildElements(data.elements);
      data.elements = [...PersonalDetails.elements, ...results];
      setForm(data);
    } catch (err) {
      console.error(err);
    }
  };

  const getDepartment = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "user",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getLocations = async () => {
    try {
      let { data } = await api.get(`/formtemplate/location`);
      setLocations(data);
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateBulkData = async () => {
    try {
      const [bulkRes, candRes] = await Promise.allSettled([
        api.get(`/candidates/BulkUpload/${candidateId}`),
        api.get(`/candidates/${candidateId}`, { tokenType: "user" }),
      ]);

      const bulkData =
        bulkRes.status === "fulfilled" ? bulkRes.value?.data || {} : {};
      const candData =
        candRes.status === "fulfilled" ? candRes.value?.data || {} : {};

      const currentLoc =
        candData?.current_location ||
        candData?.currentLocation ||
        bulkData?.current_location ||
        bulkData?.["Current Location"] ||
        candData?.personalDetails?.current_location ||
        candData?.personalDetails?.["Current Location"] ||
        candData?.personalDetails?.["current_location"] ||
        candData?.responses?.find(
          (r) =>
            (r.label || "").trim().toLowerCase().replace(/_/g, " ") ===
              "current location" ||
            (r.label || "").trim().toLowerCase() === "current_location"
        )?.value ||
        "";

      const preferredLoc =
        bulkData?.["Preferred Location"] ||
        candData?.location ||
        candData?.preferredLocation ||
        "";

      const mergedData = {
        ...candData,
        ...bulkData,
        "Current Location": currentLoc,
        current_location: currentLoc,
        "Preferred Location": preferredLoc,
      };

      if (
        mergedData?.voiceBotData &&
        mergedData?.voiceBotData?.qualification_extraction
      ) {
        if (
          (
            mergedData?.voiceBotData?.qualification_extraction || ""
          ).toLowerCase() !== "na"
        ) {
          const { data: d } = await api.post(`/candidate/getCourseType`, {
            Qualification: mergedData?.voiceBotData?.qualification_extraction,
          });
          setCourseType(d?.degree || "");
        }
      }
      setCandidateInformation(mergedData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!id || !candidateId) return;

    const init = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          getFormTemplate(),
          getCandidateBulkData(),
          getLocations(),
          getDepartment(),
        ]);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, [id, formId, candidateId]);

  //Remove child from main array -Lovejot(06-DEC-2022)
  const filterChildElements = (elementsArray) => {
    let arrr = [];
    for (let item of elementsArray) {
      if (item === null) {
        continue;
      } else {
        if (item?.type === "select" || item?.type === "radio") {
          for (let i = 0; i < item?.parent?.length; i++) {
            arrr.push(item?.parent[i]?.child?.id);
          }
        }
      }
    }
    const results = elementsArray.filter(
      (ele) => ele != null && !arrr.some((index) => index === ele.id)
    );
    return results;
  };

  useEffect(() => {
    function buildAccordions() {
      $(".form-builder-element:not(.heading)").addClass("hidden");
      $(".form-builder-element.heading .btn").on("click", function () {
        $(".form-builder-element:not(.heading)").addClass("hidden");
        let currentElements = $(this)
          .parent()
          .nextUntil(".form-builder-element.heading");
        currentElements.toggleClass("hidden");
      });
      setTimeout(openOnlyFirstAccordion, 100);
      setTimeout(addDividersBeforeHeadings, 150);
    }
    if (form.name !== "Loading form...") {
      //setTimeout(buildAccordions, 100);
    }
  }, [form]);

  // Events
  function openOnlyFirstAccordion() {
    $(".form-builder-element.heading:nth-child(1) .btn").click();
  }

  function addDividersBeforeHeadings() {
    let headings = $("#candidateForm .form-builder-element.heading").slice(1);
    $(
      `<div className="form-builder-element divider"><hr /></div>`
    ).insertBefore(headings);
  }

  async function onClickFormSubmit(event) {
    event.preventDefault();
    setError("");

    let error = [];
    setErrorInputs(error);

    let formData = [];
    let currentError = "";

    document.querySelectorAll(".form-view").forEach((input) => {
      let element = JSON.parse(input.getAttribute("data"));
      let data = {};
      let supplement = true;

      if (element !== null) {
        // Input Generation
        if (element.type === "texttable") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = {};
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']"
              )
              .forEach((textfield) => {
                let row = textfield.getAttribute("row");
                let column = textfield.getAttribute("column");
                if (value[row] === null || value[row] === undefined) {
                  value[row] = {};
                  value[row][column] = textfield.value;
                } else {
                  value[row][column] = textfield.value;
                }
              });
            data = {
              label: input.getAttribute("label"),
              value: JSON.stringify(value),
              element,
            };
          }
        } else if (element.type === "checkbox") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = [];
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']:checked"
              )
              .forEach((checkbox) => {
                if (checkbox.checked) {
                  value.push(checkbox.getAttribute("value"));
                }
              });

            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
          }
        } else if (element.type === "radio") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let radio = document.querySelector(
              "[name='" + slugify(element.properties.label) + "']:checked"
            );
            let value = null;
            if (radio !== null) {
              value = radio.value;
            }
            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
          }
        } else if (element.type === "multiSelect") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "datetime") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "capturephoto") {
          const elementWithoutValue = JSON.parse(JSON.stringify(element));
          delete elementWithoutValue.value;
          const file = base64ToFile(
            element?.value?.src || "",
            element?.value?.name,
            "image/png"
          );
          data = {
            label: element?.properties?.label,
            value: element?.value?.name,
            file: file,
            element: elementWithoutValue,
          };
        } else if (
          element.type === "file" &&
          document.getElementById(element.id).files[0] === undefined
        ) {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "statecity") {
          data = {
            label: "statecity",
            valueOfField: [
              {
                label: "Select State",
                value: element?.value?.state || "",
                element,
              },
              {
                label: "Select City",
                value: element?.value?.city || "",
                element,
              },
            ],
            element,
          };
        } else if (element.type === "departmentdesignation") {
          const { value, ...rest } = element;
          data = {
            label: "departmentdesignation",
            valueOfField: [
              {
                label: "Select Department",
                value: element?.value?.departmentText || "",
                element: rest,
                _id: element?.value?.department || "",
              },
              {
                label: "Select Designation",
                value: element?.value?.designationText || "",
                element: rest,
                _id: element?.value?.designation || "",
              },
            ],
            element: rest,
          };
        } else {
          if (input instanceof HTMLDivElement) {
            data = {
              label: input.getAttribute("label"),
              value: input.getAttribute("value"),
              element,
            };
          } else {
            data = {
              label: input.getAttribute("label"),
              value: input.value,
              element,
            };
          }
        }

        // Input Validation
        if (supplement) {
          // Validation for select type field

          if (element?.type === "capturephoto") {
            if (data.element.properties.required !== true) {
              if (!data.value) {
                currentError = `${data.element.properties.label} is required field.`;
                error.push({
                  label: data.element.properties.label,
                  value: `${data.element.properties.label} is required field.`,
                });
              }
            }
          }

          if (element.type === "statecity") {
            let checkCity = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `State and City is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `State and City is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select state"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkCity = true;
                  }
                }
                if (checkCity) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select city"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `City is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `City is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.type === "departmentdesignation") {
            let checkDesignation = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `Department and Designation is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `Department and Designation is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select department"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkDesignation = true;
                  }
                }
                if (checkDesignation) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select designation"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `Designation is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `Designation is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.properties !== null) {
            if (typeof data.value === "string") {
              let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
              if (data.element.isAlpha === true && data.value.length !== 0) {
                if (!data.value.trim().match(alphabets)) {
                  currentError = `Only alphabets are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only alphabets are allowed in ${data.label}`,
                  });
                }
              }
              //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
              let isnum = /^\d+$/;
              if (data.element.isNumber === true && data.value.length !== 0) {
                if (!isnum.test(data.value)) {
                  currentError = `Only Numbers are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only Numbers are allowed in ${data.label}`,
                  });
                }
              }

              //Dynamic Length validations for Numbers -Lovejot(12-DEC-2022)
              if (
                data.element.type === "text" ||
                data.element.type === "textarea" ||
                data.element.type === "number"
              ) {
                if (data.value.length !== 0) {
                  if (
                    data.element.properties.minLengthValidation !== undefined &&
                    data.element.properties.maxLengthValidation !== undefined
                  ) {
                    if (
                      data.value.trim().length >=
                        parseInt(data.element.properties.minLengthValidation) &&
                      data.value.trim().length <=
                        parseInt(data.element.properties.maxLengthValidation)
                    ) {
                      console.log("val error");
                    } else {
                      currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                      error.push({
                        label: data.label,
                        value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`,
                      });
                    }
                  }
                }
              }
              var emailPattern = new RegExp(
                /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
              );
              // email validation
              if (data.label.trim() === "Email" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required question.";
                error.push({
                  label: element.properties.label,
                  value: element.properties.label + " is a required question.",
                });
              } else if (
                data.label === "Email" &&
                !emailPattern.test(data.value)
              ) {
                currentError =
                  "Invalid email id format, Please fill correct email id";
                error.push({
                  label: element.properties.label,
                  value:
                    "Invalid email id format, Please fill correct email id",
                });
              }

              if (data.label === "Date of Birth") {
                var date = data.value.split("-");

                // Date of Age should be between 18-40 years

                var daterange = data.value;

                var today = new Date();
                var birthDate = new Date(daterange);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (
                  m < 0 ||
                  (m === 0 && today.getDate() < birthDate.getDate())
                ) {
                  age--;
                }
                if (age <= 17) {
                  currentError = "Age should not smaller than 18 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not smaller than 18 year",
                  });
                } else if (age > 55) {
                  currentError = "Age should not greater than 55 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not greater than 55 year",
                  });
                }
              }
              if (data.label === "Date of Birth" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required field.";
                error.push({
                  label: element.properties.label,
                  value:
                    "'" + element.properties.label + "' is a required field.",
                });
              } else if (data.label === "Date of Birth") {
                if (date[0] < 1000 || date[0].length > 4) {
                  currentError = "Please enter valid date of birth";
                  error.push({
                    label: element.properties.label,
                    value: "Please enter valid date of birth",
                  });
                }
              }
            }
          }

          if (element.properties !== null) {
            // Validate Required Inputs
            if (element.properties.required !== null) {
              if (element.properties.required === true) {
                // Validate Stringed Inputs
                if (typeof data.value === "string") {
                  //Regular expression for validation
                  if (data.label === "Date of Birth") {
                    var date = data.value.split("-");

                    // Date of Age should be between 18-40 years

                    var daterange = data.value;

                    var today = new Date();
                    var birthDate = new Date(daterange);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (
                      m < 0 ||
                      (m === 0 && today.getDate() < birthDate.getDate())
                    ) {
                      age--;
                    }
                    if (age <= 17) {
                      currentError = "Age should not smaller than 18 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not smaller than 18 year",
                      });
                    } else if (age > 55) {
                      currentError = "Age should not greater than 55 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not greater than 55 year",
                      });
                    }
                  }
                  var nameRegex = new RegExp(/[^A-Z -]/gi);
                  var languagePattern = new RegExp(/[^A-Z -,]/gi);
                  var pattern = new RegExp(/^[0-9\b]+$/);
                  var emailPattern = new RegExp(
                    /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                  );
                  // regex for email:-  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

                  // test error here
                  if (data.value.trim() === "") {
                    if (data.label === "Name" && data.value.trim() === "") {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required question.",
                      });
                    }
                  }

                  //Phone Number Validation
                  if (
                    data.label === "Phone Number" &&
                    data.value.length !== 10
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid mobile format. Please enter only 10-digit mobile number.",
                    });
                  } else if (
                    data.label === "Phone Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 10-digit mobile number.",
                    });
                  }

                  //Dynamic validations for alphabets -Lovejot(12-DEC-2022)
                  let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
                  if (
                    data.element.isAlpha === true &&
                    data.value.length !== 0
                  ) {
                    if (!data.value.trim().match(alphabets)) {
                      currentError = `Only alphabets are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only alphabets are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
                  let isnum = /^\d+$/;
                  if (
                    data.element.isNumber === true &&
                    data.value.length !== 0
                  ) {
                    if (!isnum.test(data.value)) {
                      currentError = `Only Numbers are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only Numbers are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  if (
                    data.element.type === "text" ||
                    data.element.type === "textarea" ||
                    data.element.type === "number"
                  ) {
                    if (
                      data.element.properties.minLengthValidation !==
                        undefined &&
                      data.element.properties.maxLengthValidation !== undefined
                    ) {
                      if (
                        data.value.trim().length >=
                          parseInt(
                            data.element.properties.minLengthValidation
                          ) &&
                        data.value.trim().length <=
                          parseInt(data.element.properties.maxLengthValidation)
                      ) {
                        console.log("val error");
                      } else {
                        currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                        error.push({
                          label: data.label,
                          value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.minLengthValidation} are allowed in ${data.label}`,
                        });
                      }
                    }
                  }

                  //Aadhar Number Validation
                  if (
                    data.label === "Aadhar Number" &&
                    data.value.length !== 12
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid Aadhar format. Please enter only 12-digit aadhar number.",
                    });
                  } else if (
                    data.label === "Aadhar Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 12-digit aadhar number.",
                    });
                  }

                  // Validate Address
                  if (data.label === "Address" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Address" &&
                    data.value.length >= 400
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Address should not more than 400 character",
                    });
                  }
                  // email validation
                  if (data.label === "Email" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Email" &&
                    !emailPattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid email id format, Please fill correct email id",
                    });
                  }

                  // Validate Date of birth
                  if (
                    data.label === "Date of Birth" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (data.label === "Date of Birth") {
                    if (date[0] < 1000 || date[0].length > 4) {
                      error.push({
                        label: element.properties.label,
                        value: "Please enter valid date of birth",
                      });
                    }
                  }

                  // Validation on languages
                  if (
                    data.label === "Indian Languages" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Indian Languages" &&
                    languagePattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Please enter correct languages, seperate by comma.",
                    });
                  }

                  // proper validation on the bottom of page

                  if (
                    data.element.type !== "capturephoto" &&
                    data.element.type !== "file" &&
                    data.element.type !== "statecity" &&
                    data.element.type !== "departmentdesignation"
                  ) {
                    if (
                      data.value.trim() === "" ||
                      data.value.trim() === "null"
                    ) {
                      currentError =
                        "'" +
                        element.properties.label +
                        "' is a required question. Please fill it before submission.";
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label +
                          " is a required question. Please fill it before submission.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      data.value.length !== 10
                    ) {
                      currentError =
                        "Invalid mobile format. Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid mobile format. Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      !pattern.test(data.value)
                    ) {
                      currentError =
                        "Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value: "Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Name" &&
                      data.value.length >= 40
                    ) {
                      currentError = "Name should not more than 40 character";
                      error.push({
                        label: element.properties.label,
                        value: "Name should not more than 40 character",
                      });
                    } else if (
                      data.label === "Address" &&
                      data.value.length >= 400
                    ) {
                      currentError =
                        "Address should not more than 400 character";
                      error.push({
                        label: element.properties.label,
                        value: "Address should not more than 400 character",
                      });
                    } else if (
                      data.label === "Email" &&
                      !emailPattern.test(data.value)
                    ) {
                      currentError = "Invalid email id format";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid email format, Please fill correct email",
                      });
                    } else if (data.label === "Date of Birth") {
                      if (date[0] < 1000 || date[0].length > 4) {
                        currentError = "Please enter valid date of birth";
                        error.push({
                          label: element.properties.label,
                          value: "Please enter valid date of birth",
                        });
                      }
                    }
                  }
                }
                //   Validate Non-Stringed Inputs
                if (
                  (!data.value || data.value?.length === 0) &&
                  data.element.type !== "capturephoto" &&
                  data.element.type !== "file" &&
                  data.element.type !== "statecity" &&
                  data.element.type !== "departmentdesignation"
                ) {
                  currentError =
                    "'" +
                    element.properties.label +
                    "' is a required question. Please fillss it before submission.";
                  error.push({
                    label: element.properties.label,
                    value:
                      element.properties.label +
                      " is a required question. Please fill it before submission.",
                  });
                } else if (element.properties.required === false) {
                  if (typeof data.value === "string") {
                    //Regular expression for validation
                    if (data.label === "Date of Birth") {
                      var date = data.value.split("-");

                      // Date of Age should be between 18-40 years

                      var daterange = data.value;

                      var today = new Date();
                      var birthDate = new Date(daterange);
                      var age = today.getFullYear() - birthDate.getFullYear();
                      var m = today.getMonth() - birthDate.getMonth();
                      if (
                        m < 0 ||
                        (m === 0 && today.getDate() < birthDate.getDate())
                      ) {
                        age--;
                      }
                      if (age <= 17) {
                        currentError = "Age should not smaller than 18 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not smaller than 18 year",
                        });
                      } else if (age > 55) {
                        currentError = "Age should not greater than 55 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not greater than 55 year",
                        });
                      }
                    }
                  }
                }
              }
            }
            // Validate with Browser Validity
            try {
              if (input.checkValidity() === false) {
                currentError =
                  "'" +
                  element.properties.label +
                  "' contains an invalid answer. " +
                  input.validationMessage;
                error.push({
                  label: element.properties.label,
                  value: input.validationMessage,
                });
              }
            } catch (e) {}
          }
        }
      }

      if (supplement && data !== null && JSON.stringify(data) !== "{}") {
        if (data?.valueOfField && Array.isArray(data.valueOfField)) {
          formData = [...formData, ...data.valueOfField];
        } else {
          formData.push(data);
        }
      }
    });

    let payload = new FormData();

    if (form?.elements?.length !== 0) {
      form?.elements?.forEach((ele) => {
        if (ele.type === "file") {
          let file = document.getElementById(ele.id).files[0];
          if (file) {
            let extension = file.name.split(".").pop().toLowerCase();
            let ext = [];
            for (let key in ele.extensions) {
              if (ele.extensions[key]) {
                ext.push(key);
              }
            }
            let size = file.size <= parseInt(ele.properties.size) * 1024;
            if (!size) {
              currentError = `Your ${ele.properties.label} must not be larger than ${ele?.properties.size} kb`;
              error.push({
                label: ele.properties.label,
                value: `Your ${ele.properties.label} must not be larger than ${ele?.properties.size} kb`,
              });
            } else {
              if (ext.includes(extension)) {
                payload.append(ele.properties.label, file);
              } else {
                currentError = `The image is in an unsupported extension '${extension}'.`;
                error.push({
                  label: ele.properties.label,
                  value: `The image is in an unsupported extension '${extension}'.`,
                });
              }
            }
          } else {
            const fieldName = ele.properties.label;
            if (
              fieldName.toLowerCase().indexOf("video introduction") === -1 &&
              fieldName.toLowerCase().indexOf("resume upload") === -1 &&
              fieldName.toLowerCase().indexOf("profile photo") === -1
            ) {
              if (
                ele.properties.required &&
                (ele.value === "" || ele.value === undefined)
              ) {
                currentError = `You must attach your ${ele.properties.label}`;
                error.push({
                  label: ele.properties.label,
                  value: `You must attach your ${ele.properties.label}`,
                });
              }
            }
          }
        }
      });
    }

    formData = formData?.map((key) => {
      if (key.element.type === "capturephoto") {
        if (key.file) {
          payload.append(key.label, key.file);
        }
        const { file, ...rest } = key;
        return rest;
      }
      return key;
    });

    // Handle Form Submission
    if (currentError === "" && error.length === 0) {
      setLoad(true);
      payload.append("response", JSON.stringify(formData));
      payload.append("form", id);

      await Axios.put(url("candidate/" + candidateId), payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
        .then((result) => {
          setSuccess(true);
          localStorage.setItem("ids", result.data.id);
          const candidateId = result.data.id;

          if (SOURCE_PAGE === "interview" && IDS !== null) {
            const [designationId, interviewId, interviewNamesId] =
              IDS.split(",");
            history.push(
              `/interview/process/${designationId}/${interviewId}/${interviewNamesId}/${candidateId}?tab=${TAB}`
            );
          } else {
            history.push(`/candidate/${candidateId}?tab=${TAB}`);
          }
        })
        .catch((error) => {
          if (error.response.data.error.name === "MongoError") {
            setError("Email is already in use. Please use another email.");
          } else if (error.response.data.error === "Mobile No already Exist") {
            setError(
              "Mobile number is already in use. Please use another mobile number."
            );
          } else {
            setError("Email already exist!");
          }
        })
        .finally(() => {
          setLoad(false);
        });
    } else {
      const map = new Map();
      error.forEach((item) => {
        map.set(item.label, item);
      });
      const filtered = Array.from(map.values());
      setErrorInputs(filtered);
      setLoad(false);
    }
  }

  return (
    <Dashboard>
      {!isConsultant() && (
        <>
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className=" mt-4 p-3 bg-white rounded">
                <If test={isLoading === true}>
                  <h1>Loading form...</h1>
                  <Else>
                    <h1 className="candidate-form-title">{form.name}</h1>
                    <hr />
                    <div className="my-5" id="candidateForm">
                      {form.elements.map((element, key) => {
                        if (candidateInformation !== undefined || null) {
                          for (const [key, value] of Object.entries(
                            candidateInformation
                          )) {
                            if (`${key}` === element.properties.label) {
                              element.properties.value = value;
                            }

                            if (
                              key === "How did you come to know about us" &&
                              value === "Apna jobs" &&
                              element.properties.label ===
                                "How did you come to know about us"
                            ) {
                              element.properties.value = "Job Portal";
                            }


                            if (key === "voiceBotData") {
                              if (
                                element?.properties?.label ==
                                  "Languages Known" &&
                                (
                                  value?.English_and_Hindi || ""
                                ).toLowerCase() === "yes"
                              ) {
                                element.properties.value = ["English", "Hindi"];
                              }
                              if (
                                element?.properties?.label ==
                                  "Highest Qualification" &&
                                value?.qualification_extraction
                              ) {
                                element.properties.value = courseType;
                              }
                              if (
                                element?.properties?.label ==
                                  "Preferred Location" &&
                                value?.wfo_preferred_location
                              ) {
                                let loc = (
                                  value?.wfo_preferred_location || ""
                                ).trim();
                                let locLower = loc.toLowerCase();

                                if (
                                  locLower === "gurgaon" ||
                                  locLower === "gurugram"
                                )
                                  loc = "Gurugram";

                                if (
                                  locations
                                    .map((l) => l.toLowerCase())
                                    .includes(locLower)
                                ) {
                                  element.properties.value = loc;
                                }
                              }
                              // Prefill DOB from voiceBotData as fallback
                              if (
                                element?.properties?.label === "Date of Birth" &&
                                !element.properties.value &&
                                value?.dob
                              ) {
                                try {
                                  const dateMatch = String(value.dob).match(/^\d{4}-\d{2}-\d{2}/);
                                  if (dateMatch) {
                                    element.properties.value = dateMatch[0];
                                  }
                                } catch (e) {
                                  console.error("Error parsing voiceBotData dob:", e);
                                }
                              }
                            }

                            if (
                              element.type === "file" ||
                              element.type === "capturephoto"
                            ) {
                              const fieldName = element.properties.label;
                              if (
                                fieldName
                                  .toLowerCase()
                                  .indexOf("video introduction") === 0 ||
                                fieldName
                                  .toLowerCase()
                                  .indexOf("resume upload") === 0 ||
                                fieldName
                                  .toLowerCase()
                                  .indexOf("profile photo") === 0
                              ) {
                                element.isMandate = false;
                              }
                            }
                          }

                          // Prefill Current Location from candidate data
                          const isCurrentLocationField =
                            element?.properties?.label &&
                            (element.properties.label.trim().toLowerCase() === "current location" ||
                             element.properties.label.trim().toLowerCase() === "current_location" ||
                             element.properties.label.trim().toLowerCase() === "select current location" ||
                             element.properties.label.trim().toLowerCase().replace(/_/g, " ") === "current location");

                          if (isCurrentLocationField && candidateInformation) {
                            const curLocVal =
                              candidateInformation?.["Current Location"] ||
                              candidateInformation?.current_location ||
                              candidateInformation?.currentLocation ||
                              candidateInformation?.personalDetails?.current_location ||
                              candidateInformation?.personalDetails?.["Current Location"] ||
                              candidateInformation?.personalDetails?.["current_location"] ||
                              candidateInformation?.responses?.find(
                                (r) =>
                                  (r.label || "").trim().toLowerCase().replace(/_/g, " ") === "current location" ||
                                  (r.label || "").trim().toLowerCase() === "current_location"
                              )?.value ||
                              "";

                            if (curLocVal) {
                              let curLocStr = Array.isArray(curLocVal)
                                ? curLocVal[0]
                                : curLocVal;
                              element.properties.value = String(curLocStr || "").trim();
                            }
                          }

                          if (
                            element.type === "radio" ||
                            element.type === "select"
                          ) {
                            if (element.parent.length !== 0) {
                              for (let j = 0; j < element.parent.length; j++) {
                                for (const [key, value] of Object.entries(
                                  candidateInformation
                                )) {
                                  if (
                                    `Select Job Portal.` ===
                                      element.parent[j].child.properties
                                        .label &&
                                    key ===
                                      "How did you come to know about us" &&
                                    value === "Apna jobs"
                                  ) {
                                    element.parent[j].child.properties.value =
                                      value;
                                  }
                                }
                              }
                            }
                          }
                        }

                        element.editable = true;

                        return (
                          <GetFormComponent
                            element={element}
                            key={key}
                            departments={departments}
                            errorInputs={errorInputs}
                            tokenType="user.token"
                            form={{
                              ...candidateInformation,
                              files: [],
                            }}
                            formId={id}
                            formType={"Joining"}
                            getCandidateDetails={() => {}}
                          />
                        );
                      })}
                    </div>
                    <div className="mb-5">
                      <If test={error !== ""}>
                        <div className="alert alert-danger">{error}</div>
                      </If>
                      {/* <div className="form-check mb-5">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="agreement"
                      checked={agreed}
                      onChange={() => {
                        // setAgreed((b) => !b);
                        // setStatus(!status);
                      }}
                    />
                    <label className="form-check-label" for="agreement">
                      I agree to all the terms and conditions.
                    </label>
                  </div> */}
                      <button
                        className={cx(
                          "btn",
                          { "btn-primary":true},
                        )}
                        type="submit"
                        onClick={onClickFormSubmit}
                        // disabled={!agreed}
                      >
                        Submit
                      </button>
                    </div>
                  </Else>
                </If>
              </div>
            </div>
          </div>
        </>
      )}
    </Dashboard>
  );
}

export default CandidateEdit;
